import i18n, { InitOptions } from 'i18next'
import { initReactI18next } from 'react-i18next'
import tr from 'i18n/tr'
import en from 'i18n/en'
import az from 'i18n/az'
import ru from 'i18n/ru'

const resources = {
  tr,
  en,
  az,
  ru,
}

i18n.use(initReactI18next).init({
  resources,
  lng: 'tr',
  fallbackLng: 'tr',
  react: {
    transSupportBasicHtmlNodes: true,
    transKeepBasicHtmlNodesFor: ['i'],
  },
  keySeperator: false,
  interpolation: {
    escapeValue: false,
  },
} as InitOptions)

export default i18n
